import { render, staticRenderFns } from "./GoodsOrders.vue?vue&type=template&id=ea803a46&scoped=true"
import script from "./GoodsOrders.vue?vue&type=script&lang=js"
export * from "./GoodsOrders.vue?vue&type=script&lang=js"
import style0 from "./GoodsOrders.vue?vue&type=style&index=0&id=ea803a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea803a46",
  null
  
)

export default component.exports